import request, { METHODS } from '@/api'
import UrlConfig from "@/api/UrlConfigs";
// 坐席配置
export function getSeatAccount(current,pageSize,params) {
    return request(`${UrlConfig.Clue.GetSeatAccountPage}/${current}/${pageSize}`, {
        method: METHODS.POST,
        data: params,
    })
}
// 更改绑定状态
export function updateBindState(params) {
    return request(UrlConfig.Clue.UpdateSeatAccountBindState, {
        method: METHODS.POST,
        data: params,
    })
}

// 线索-更新最近通话时间
export function updateLastCallTime(clueId) {
    return request(UrlConfig.PlusCrmWeb.UpdateLastCallTime + clueId, {
        method: METHODS.POST,
    })
}